//import MainFullLayout4i from '../layouts/mainfull.js';
import { loadingIcon } from '../../common/helpers/loadingicon.js';

const loadMorePanel = document.querySelector("#loadMorePanel");
let swaggingRightsGrid;
let isAddMoreRunning = false;

async function init() {
   // MainFullLayout4i.init();

    swaggingRightsGrid = await initializeGrid();
    bindOverlayOnImages();
    setUpResizeEvents();

    document.addEventListener("click", swagEvents);
    loadMorePanel.classList.toggle("hide");
}

async function swagEvents(e) {
    if(e.target.id === "loadMoreBtn") {
        e.preventDefault();
        loadMorePosts();
    }else if(e.target.classList.contains("swagPost")){
        e.preventDefault();
        const imageDialog = await loadStoryDialog();
        if(imageDialog) imageDialog.open(e, e.target);      
    }
}

async function initializeGrid() {
    const posts = await loadPosts();
    const { default: MasonryGrid } = await import('../../common/masonrygrid.js');
    const container = document.querySelector('#container');
    return new MasonryGrid(container, posts);
}

async function loadPosts(skip = 0) {
    try {
        const response = await fetch(`/swaggingrights/loadimages/${skip}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' },
        });
        return response.ok ? await response.json() : [];
    } catch {
        return [];
    }
}

function bindOverlayOnImages() {
    const swagPhotos = document.querySelectorAll(".swagPost");
    swagPhotos.forEach((el) => {
        el.addEventListener("keydown", hideOverlayOnEscape);
        el.addEventListener("mouseenter", showOverlay);
        el.addEventListener("mouseleave", hideOverlay);
        el.addEventListener("focus", showOverlay);
        el.addEventListener("blur", hideOverlay);
    });
}

function showOverlay(e) {
    hideOverlay();
    e.currentTarget.classList.add("showOverlay");
}

function hideOverlay(){
    document.querySelector(".showOverlay")?.classList.remove("showOverlay");
}

function hideOverlayOnEscape(e) {
    if (e.key === "Escape") hideOverlay();
}

async function loadMorePosts() {
    loadMorePanel.classList.toggle("hide");
    document.querySelector("#loadMorePanel").insertAdjacentHTML("afterend", loadingIcon);
    await addMorePosts();

    if (!isAddMoreRunning) {
        loadMorePanel.classList.toggle("hide");
        removeLoadingSpinner();
    }
}

async function addMorePosts() {
    if (isAddMoreRunning) return;

    isAddMoreRunning = true;
    const oldPostCount = swaggingRightsGrid.posts.length;
    const posts = await loadPosts(oldPostCount);

    swaggingRightsGrid.addPosts(posts);
    const newPosts = document.querySelectorAll(".swagPost");

    bindOverlayOnImages();
    newPosts[oldPostCount]?.focus();
    isAddMoreRunning = false;
}

function removeLoadingSpinner() {
    document.querySelector(".spinner")?.remove();
}

function setUpResizeEvents() {
    const events = ["load", "resize"];
    events.forEach((event) => {
        window.addEventListener(event, swaggingRightsGrid.resizeAllMasonryItems);
    });
}


// Cache promises for lazy loading 
let storyDialogPromise = null;

// Lazy load image dialog
async function loadStoryDialog() {
    if (!storyDialogPromise) {
        storyDialogPromise = import('./modules/storydialog.js')
            .then(({ default: SwagStoryDialog }) => {
                SwagStoryDialog.init(swaggingRightsGrid);
                return SwagStoryDialog;
            })
            .catch((error) => {
                console.error("Failed to load swag story dialog:", error);
                storyDialogPromise = null; // Reset to allow retry
                return null;
            });
    }
    return storyDialogPromise;
}

await init();